import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Github, Linkedin, Twitter, HelpCircle } from 'lucide-react';

const Footer = ({ variant = 'default' }) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  
  // Determine variant based on route if not explicitly provided
  const actualVariant = variant === 'default' && location.pathname.startsWith('/portal') 
    ? 'portal' 
    : variant;

  // Super Admin Color Palette (consistent across all portals)
  // All variants use the same color scheme for consistency
  const colors = {
    backgroundColor: '#F8FCFB',
    borderColor: '#E5EFF3',
    headingColor: '#0B2530',
    textColor: '#4A5B63',
    linkHoverColor: '#006600',
    iconHoverColor: '#006600',
    copyrightColor: '#8A9AA2',
    linkHoverBg: '#E0F8F3'
  };

  return (
    <footer 
      className="w-full border-t"
      style={{ 
        backgroundColor: colors.backgroundColor,
        borderColor: colors.borderColor,
        margin: 0,
        padding: 0
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 
              className="text-lg font-semibold mb-2"
              style={{ color: colors.headingColor }}
            >
              HelpDesk Platform
            </h3>
            <p 
              className="text-sm mb-2 max-w-md"
              style={{ color: colors.textColor }}
            >
              Enterprise helpdesk solution for managing tickets, knowledge base, and customer support operations.
            </p>
            {/* <div className="flex items-center gap-4">
              <a
                href="mailto:support@helpdesk.com"
                className="p-2 rounded-lg transition-colors"
                style={{ color: '#585858' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colors.linkHoverBg;
                  e.currentTarget.style.color = colors.iconHoverColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#585858';
                }}
              >
                <Mail className="h-5 w-5" />
              </a>
              <a
               onClick={() => window.open('https://twitter.com', '_blank')}
                className="p-2 rounded-lg transition-colors"
                style={{ color: '#585858' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colors.linkHoverBg;
                  e.currentTarget.style.color = colors.iconHoverColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#585858';
                }}
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                onClick={() => window.open('https://in.linkedin.com/', '_blank')}
                className="p-2 rounded-lg transition-colors"
                style={{ color: '#585858' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colors.linkHoverBg;
                  e.currentTarget.style.color = colors.iconHoverColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#585858';
                }}
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="p-2 rounded-lg transition-colors"
                style={{ color: '#585858' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colors.linkHoverBg;
                  e.currentTarget.style.color = colors.iconHoverColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#585858';
                }}
              >
                <Github className="h-5 w-5" />
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 
              className="text-sm font-semibold mb-2"
              style={{ color: colors.headingColor }}
            >
              Quick Links
            </h4>
            <ul className="flex flex-wrap gap-x-4 gap-y-1">
              <li>
                <Link
                  // to="/portal/home"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor ,fontWeight: 'bold'}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  // to="/portal/knowledgebase"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor ,fontWeight: 'bold'}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  Knowledge Base
                </Link>
              </li>
              <li>
                <Link
                  // to="/portal/tickets/create"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor ,fontWeight: 'bold'}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  Create Ticket
                </Link>
              </li>
              <li>
                <Link
                  // to="/help"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  <HelpCircle className="inline h-4 w-4 mr-1" />
                  Help Center
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            {/* <h4 
              className="text-sm font-semibold mb-4"
              style={{ color: colors.headingColor }}
            >
              Resources
            </h4> */}
            {/* <ul className="space-y-2"> 
              <li>
                <Link
                  to="/docs"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  Documentation
                </Link>
              </li>
              <li>
                <Link
                  to="/api-docs"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  API Reference
                </Link>
              </li>
              <li>
                <Link
                  to="/changelog"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  Changelog
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="text-sm transition-colors block"
                  style={{ color: colors.textColor }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.linkHoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textColor;
                  }}
                >
                  Support
                </Link>
              </li>
            </ul> */}
          </div>
        </div>

        {/* Bottom Bar */}
        <div 
          className="mt-3 pt-3 border-t flex flex-col sm:flex-row justify-between items-center gap-3"
          style={{ borderColor: colors.borderColor }}
        >
          <p 
            className="text-sm"
            style={{ color: colors.copyrightColor }}
          >
            © {currentYear} HelpDesk Platform. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="text-sm transition-colors"
              style={{ color: colors.copyrightColor }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = colors.linkHoverColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = colors.copyrightColor;
              }}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm transition-colors"
              style={{ color: colors.copyrightColor }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = colors.linkHoverColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = colors.copyrightColor;
              }}
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
